import { createSelector } from 'reselect';
import { KEY, TicketingState, Config } from './types';
import { GlobalState } from 'store/types';

const findByPropertyAndConfig = <T, K extends keyof T>(data: T[], property: K, config: Config) => {
  // @ts-expect-error there will be a lowercase to the property
  return data.find((d) => d[property].toString().toLowerCase() === config.selected.toString().toLowerCase());
};

const getTicketingState = (state: GlobalState) => state[KEY] as TicketingState;

const selectPreferredDeliveryMethod = createSelector(
  getTicketingState,
  (ticketing) => ticketing.delivery.preferredMethod
);

const selectDeliveryEmail = createSelector(getTicketingState, (ticketing) => ticketing.delivery.email);

const selectDeliveryPhoneNumber = createSelector(getTicketingState, (ticketing) => ticketing.delivery.phone);

const selectDeliveryStatus = createSelector(getTicketingState, (ticketing) => ticketing.delivery.status);

const selectSession = createSelector(getTicketingState, (ticketing) => ticketing.session);

const selectLoading = createSelector(getTicketingState, (ticketing) => ticketing.loading);

const selectError = createSelector(getTicketingState, (ticketing) => ticketing.error);

const selectEvents = createSelector(getTicketingState, (ticketing) => ticketing.events);

const selectEvent = createSelector(getTicketingState, (ticketing) => {
  if (ticketing.upsellProducts && ticketing.upsellProducts.length) {
    return findByPropertyAndConfig(ticketing.upsellProducts, 'id', ticketing.eventsConfig);
  }
  return findByPropertyAndConfig(ticketing.events, 'id', ticketing.eventsConfig);
});

const selectGenresConfig = createSelector(getTicketingState, (ticketing) => ticketing.genresConfig);

const selectEventsConfig = createSelector(getTicketingState, (ticketing) => ticketing.eventsConfig);

const selectTiersConfig = createSelector(getTicketingState, (ticketing) => ticketing.tiersConfig);

const selectMembershipProductConfig = createSelector(
  getTicketingState,
  (ticketing) => ticketing.membershipProductConfig
);

const selectEventDetails = createSelector(getTicketingState, (ticketing) => ticketing.eventDetails);

const selectMembershipProduct = createSelector(getTicketingState, (ticketing) => ticketing.membershipProduct);

const selectPriceTypePromoCode = createSelector(getTicketingState, (ticketing) => ticketing.priceTypePromoCode);

const selectMembershipDetails = createSelector(getTicketingState, (ticketing) => ticketing.membershipDetails);

const selectAppliedPriceTypePromo = createSelector(getTicketingState, (ticketing) => ticketing.appliedPriceTypePromo);

const selectFetchCompleted = createSelector(getTicketingState, (ticketing) => ticketing.fetchCompleted);

const selectTicketingConfigPath = createSelector(getTicketingState, (ticketing) => ticketing.configPath);

const selectNavigationPath = createSelector(getTicketingState, (ticketing) => ticketing.navigationPath);

const selectTimerOverlay = createSelector(getTicketingState, (ticketing) => ticketing.timerOverlay);

const selectUpsell = createSelector(getTicketingState, (ticketing) => ticketing.upsell);

const selectUpsellProducts = createSelector(getTicketingState, (ticketing) => ticketing.upsellProducts);

export const selectors = {
  selectSession,
  selectLoading,
  selectError,
  selectEvents,
  selectEvent,
  selectEventDetails,
  selectMembershipProduct,
  selectGenresConfig,
  selectEventsConfig,
  selectTiersConfig,
  selectMembershipProductConfig,
  selectPriceTypePromoCode,
  selectMembershipDetails,
  selectAppliedPriceTypePromo,
  selectPreferredDeliveryMethod,
  selectDeliveryEmail,
  selectDeliveryPhoneNumber,
  selectDeliveryStatus,
  selectFetchCompleted,
  selectTicketingConfigPath,
  selectNavigationPath,
  selectTimerOverlay,
  selectUpsell,
  selectUpsellProducts
};
